import { render, staticRenderFns } from "./All_product.vue?vue&type=template&id=bfbefb14&scoped=true"
import script from "./All_product.vue?vue&type=script&lang=js"
export * from "./All_product.vue?vue&type=script&lang=js"
import style0 from "./All_product.vue?vue&type=style&index=0&id=bfbefb14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbefb14",
  null
  
)

export default component.exports